/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_images_js
	 ********************************************/
	(function ProductImagesModule() {
		var $imageModules;
		var scrollDir = true;
		var scrollCount = 0;
		var imageCount;
		var $productImages;
		var mobileBreakPoint = 768; // iPad
		var visibleAllowance = 3; // Show 3 Thumbnail Images
		var thumbnailMargin = 10; // 10px Padding
		var mediaPlayer = null;

		function loadFancyboxModal($module) {
			var $secondaryImages = $module.find('.product-secondary-image');
			var activeIdx = 0;
			var carouselImages = rp$.map($secondaryImages, function(imageEle, idx) {
				var $image = rp$(imageEle);
				var type = $image.data('image-type');

				if($image.hasClass('active')) {
					activeIdx = idx;
				}
				if (type === 'YOUTUBE') {
					return {
						type: 'iframe',
						href: 'https://www.youtube.com/embed/'+ $image.data('image-id'),
					};
				} else {
					return {
						type: 'image',
						href: $image.data('image-main-url'),
						title: $image.data('caption'),
					};
				}
			});
			if (carouselImages.length === 0) {
				var $mainImageLink = rp$('.product-main-image-link');
				var $mainImageEl = $mainImageLink.find('.product-main-image');
				carouselImages.push({
					href: $mainImageEl.attr('src'),
					title: $mainImageLink.data('fancybox-title'),
				});
			}

			rp$.fancybox(carouselImages, {
				index: activeIdx,
				parent: '#rp_webstore',
			});
		}

		function selectMedia($module, $image) {
			var $productImageWrap = $module.find('.product-main-image-link');
			var $productImage = $module.find('.product-main-image');
			var $productVideo = $module.find('.product-video');
			var $productImages = $module.find('.product-images');
			var $productImageCaption = $module.find('.product-main-image-caption');

			var image = {
				id: $image.attr('data-image-id'),
				type: $image.attr('data-image-type'),
				preview: $image.attr('data-image-preview-url'),
				caption: $image.attr('data-caption'),
			};



			// Set Active Flag On secondary images
			$module.find('.product-secondary-image').removeClass('active');
			$image.addClass('active');

			if(image.type === 'YOUTUBE') {
				$productImageWrap.hide();
				$productVideo.show();

				// Make sure that target <DIV> exists
				$productVideo.empty();
				$productVideo.append('<div id="product_image_video"></div>');

				// Load the YouTube Player
				if (window.YT && window.YT.Player) {
					mediaPlayer = new window.YT.Player('product_image_video', {
						height: '260',
						width: '350',
						videoId: image.id,
						playerVars: {
							rel: 0, // No Related Videos
							modestbranding: 1, // Modest Branding
							iv_load_policy: 3, // No video annotations
						},
					});
				}

			} else {
				$productVideo.hide();
				if (mediaPlayer && typeof mediaPlayer.destroy === 'function') {
					mediaPlayer.destroy();
					mediaPlayer = null;
				}
				$productImageWrap.show();
				$productImage.attr('src', image.preview);
			}

			if(image.caption) {
				$productImageCaption.html(image.caption);
				$productImages.addClass('show-caption');
			} else {
				$productImageCaption.html('');
				$productImages.removeClass('show-caption');
			}
		}

		function thumbnailScroll($module, vertCarouselButton, scrollMax) {
			var $scrollContainer = $module.find('.secondary-images');
			var imageHeight = $scrollContainer.find('.product-secondary-image').height();

			// Scroll up or down
			if(scrollCount >= 0 && scrollDir === true) {
				scrollCount++;
				$scrollContainer.css('top', "-="+(imageHeight+thumbnailMargin));
				if(scrollCount >= scrollMax) {
					scrollDir = false;
					vertCarouselButton.addClass('buttonDown').removeClass('buttonUp');
				}
			} else if(scrollDir === false) {
				scrollCount--;
				$scrollContainer.css('top', "+="+(imageHeight+thumbnailMargin));
				if(scrollCount === 0) {
					scrollDir = true;
					vertCarouselButton.addClass('buttonUp').removeClass('buttonDown');
				}
			}

			// Wait for animation to complete / Prevent Spam click
			vertCarouselButton.css('pointer-events', "none");
			setTimeout(function(){vertCarouselButton.css('pointer-events', "auto")}, 260);
		}

		function mobileOwlCarousel() {
			var productImages = rp$('.secondary-images');

			// Load Carousel if under 768 pixels
			if(rp$(window).width() < mobileBreakPoint && imageCount > visibleAllowance && typeof rp$.fn.owlCarousel === 'function') {
				productImages.addClass('owl-carousel').owlCarousel({
					margin: 8,
					nav: true,
					navText: false,
					loop: true,
					responsive: {
						0: {
							items: 3
						},
						500: {
							items: 4
						}
					}
				});
			} else if(productImages.hasClass('owl-carousel')){
				productImages.trigger('destroy.owl.carousel').removeClass('owl-carousel');
			}
		}

		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$imageModules = rp$('.product-images-module');

			rp$.each($imageModules, function MobileCarousel_Iterator(idx, imagesModule) {
				var $imagesModule = rp$(imagesModule);
				$productImages = $imagesModule.find('.secondary-images');

				// Static desktop selectors
				var $thumbButton = $imagesModule.find('.thumbnails-scroll-button');
				var $ulWrap = $imagesModule.find('.secondary-images-wrapper');
				var imageHeight = $imagesModule.find('.product-secondary-image').height();
				imageCount = $imagesModule.find('.product-secondary-image').length;
				var thumbsHeight = imageCount * imageHeight;

				// Set ScrollMax
				var scrollMax = 0;
				if(rp$(window).width() > mobileBreakPoint) {
					if(thumbsHeight <= $ulWrap.height()) {
						scrollMax = 0;
						$thumbButton.hide();
					} else {
						scrollMax = imageCount - visibleAllowance;
						$thumbButton.show();
					}
				}

				/* Carousel Variables
				.*-----------------------------------------*/
				// Decide on owl carousel or not
				mobileOwlCarousel(imageCount);

				/* Handle Image click
				.*-----------------------------------------*/
				$productImages.on('click', '.product-secondary-image', function SelectProductImage(e) {
					e.preventDefault();
					selectMedia($imagesModule, rp$(this));
				});

				$imagesModule.on('click', '.enlarge-image-overlay', function clickToEnlarge(e) {
					e.preventDefault();
					loadFancyboxModal($imagesModule);
				});

				// Thumbnail Button click
				$thumbButton.click(function(e) {
					e.preventDefault();
					thumbnailScroll($imagesModule, rp$(this), scrollMax);
				});

			});
		}

		rp$(document).on('setProductImages:html', function HandleNewProductImagesHtml(evt, html) {
			rp$('.product-images-module').html(html);
			attachEvents();
		});

		// Reset on resize.
		rp$(window).resize(function(){
			rp$('.secondary-images').css('top', "0"); // Reset vertical scroll
			rp$('.thumbnails-scroll-button').addClass('buttonUp').removeClass('buttonDown');
			scrollDir = true;
			scrollCount = 0;
			mobileOwlCarousel(imageCount); // Destroy/Create Owl Carousel
		});

		$onReady({
			rp$, window,
			label: 'product_images',
			fn: attachEvents,
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
